import { observer } from 'mobx-react-lite'
import React from 'react'
import { Button, Dropdown, type IDropdownProps } from 'shared/ui'
import { useTextToSpeechContext } from 'widgets/TextToSpeech/context/context'
import { DefaultVoiceContent } from 'widgets/TextToSpeech/ui/TextToSpeechVoice/VoicesContent/variants/DefaultVoiceContent'
import { TextToSpeechVoiceConfigDefault } from 'widgets/TextToSpeech/ui/TextToSpeechVoice/store/TextToSpeechVoiceConfigDefault'
import styles from './styles.module.scss'

export type ITextToSpeechVoiceProps = {
  customComponent?: IDropdownProps['customComponent']
}

export const TextToSpeechVoice = observer(({ customComponent }: ITextToSpeechVoiceProps) => {
  const { selectedVoice, configStore } = useTextToSpeechContext()
  return (
    <div className={styles.wrap}>
      <Dropdown
        placement={'bottom-start'}
        width={340}
        customComponent={
          customComponent ||
          (configStore instanceof TextToSpeechVoiceConfigDefault &&
            ((onCloseMenu) => (
              <DefaultVoiceContent onCloseMenu={onCloseMenu} store={configStore} />
            ))) ||
          undefined
        }
        triggerComponent={(open) => (
          <Button
            disabled={!selectedVoice}
            active={open}
            icon={'voice'}
            iconRight={open ? 'chevronUp' : 'chevronDown'}
            typeBtn={'text'}
            size={'small'}
            text={selectedVoice?.name}
            tooltipProps={{
              label: 'Voices',
              placement: 'top',
              visibility: open ? 'hidden' : 'visible',
            }}
          />
        )}
      />
    </div>
  )
})
